<div class="content-box"></div>

<!-- TODO check loader colors -->

<div class="branded-movie-conversion--top-menu">
  <div class="branded-movie-conversion--top-menu--channel">
    <!-- CUSTOM HEADER IMAGES -->
    @if (customHeaderImages()) {
      @for (image of customHeaderImages() || []; track image) {
        @if (!image?.hideOnHeaderLg || !image?.hideOnHeaderSm) {
          @if (image.url && image.externalLink) {
            <a
              class="branded-movie-awareness--top-menu--channel--link"
              [href]="image.externalLink"
              target="_blank"
              rel="noopener noreferrer"
              [class.hiddenOnLg]="image.hideOnHeaderLg"
            >
              <img
                [ngSrc]="image.src"
                [attr.alt]="image.alt"
                [width]="image.width"
                [height]="image.height"
                [class.hiddenOnLg]="image.hideOnHeaderLg"
                [class.hiddenOnSm]="image.hideOnHeaderSm"
              />
            </a>
          } @else if (image.url) {
            <a class="branded-movie-awareness--top-menu--channel--link" [routerLink]="image.url">
              <img
                [ngSrc]="image.src"
                [attr.alt]="image.alt"
                [width]="image.width"
                s
                [height]="image.height"
                [class.hiddenOnLg]="image.hideOnHeaderLg"
                [class.hiddenOnSm]="image.hideOnHeaderSm"
              />
            </a>
          } @else {
            <img
              [ngSrc]="image.src"
              [attr.alt]="image.alt"
              [width]="image.width"
              [height]="image.height"
              [class.hiddenOnLg]="image.hideOnHeaderLg"
              [class.hiddenOnSm]="image.hideOnHeaderSm"
            />
          }
        }
      }
      <!-- END CUSTOM HEADER IMAGES -->
    } @else if (logoExternalLink) {
      <a class="branded-movie-conversion--top-menu--channel--link" [href]="logoExternalLink" target="_blank">
        <img [src]="channelLogoUrl" [attr.alt]="channelName() + ' logo'" />
      </a>
    } @else {
      <a class="branded-movie-conversion--top-menu--channel--link" [routerLink]="!appHasOnlyMovies ? '/' : null">
        <img [src]="channelLogoUrl" [attr.alt]="channelName() + ' logo'" />
      </a>
    }
  </div>
  <div class="branded-movie-conversion--top-menu--mobile-menu no-padding">
    <lib-shared-feature-sidemenu
      linkClass="branded-movie-conversion--top-menu--mobile-menu--link"
      [appendTo]="element"
      closeIconFontSize="var(--sidemenu-icon__fontSize, 28px)"
      closeIconColor="var(--brand-color-contrast-support-contrast)"
    >
      <div class="branded-movie-conversion--sidebar branded-movie-conversion--sidebar--nav">
        @for (link of sectionsHyperLink(); track link) {
          <a [routerLink]="[routePath, 'film-info']" [fragment]="link.ref" [attr.data-translate]="link.label">{{
            link.label | translate: { placeholder: link.placeholder }
          }}</a>
        }

        <!-- @if (movie && hasAssets) {
          <div class="branded-movie-conversion--sidebar--assets">
            <ush-assets-locker-link
              [movie]="movie"
              [hideLabel]="true"
              [label]="ASSETSLOCKER_LABEL"
              [labelButton]="ASSETSLOCKER_LABEL_BUTTON"
            />
          </div>
        } -->

        @if (movie) {
          <div class="branded-movie-conversion--sidebar--sharing">
            <ush-movie-tell-friends [movie]="movie!" />
          </div>
        }

        <div class="branded-movie-conversion--sidebar--channel">
          <!-- CUSTOM HEADER IMAGES -->
          @if (customHeaderImages()) {
            @for (image of customHeaderImages() || []; track image) {
              @if (!image?.hideOnSideMenu) {
                @if (image.url && image.externalLink) {
                  <a
                    class="branded-movie-awareness--top-menu--channel--link"
                    [href]="image.externalLink"
                    target="_blank"
                    rel="noopener noreferrer"
                    [class.hiddenOnLg]="image.hideOnHeaderLg"
                  >
                    <img
                      [ngSrc]="image.src"
                      [attr.alt]="image.alt"
                      [width]="image.width"
                      [height]="image.height"
                      [class.hiddenOnLg]="image.hideOnHeaderLg"
                      [class.hiddenOnSm]="image.hideOnHeaderSm"
                    />
                  </a>
                } @else if (image.url) {
                  <a class="branded-movie-awareness--top-menu--channel--link" [routerLink]="image.url">
                    <img
                      [ngSrc]="image.src"
                      [attr.alt]="image.alt"
                      [width]="image.width"
                      s
                      [height]="image.height"
                      [class.hiddenOnLg]="image.hideOnHeaderLg"
                      [class.hiddenOnSm]="image.hideOnHeaderSm"
                    />
                  </a>
                } @else {
                  <img
                    [ngSrc]="image.src"
                    [attr.alt]="image.alt"
                    [width]="image.width"
                    [height]="image.height"
                    [class.hiddenOnLg]="image.hideOnHeaderLg"
                    [class.hiddenOnSm]="image.hideOnHeaderSm"
                  />
                }
              }
            }
            <!-- END CUSTOM HEADER IMAGES -->
          } @else {
            <a class="branded-movie-conversion--sidebar--channel--link" [routerLink]="!appHasOnlyMovies ? '/' : null">
              <img [src]="channelLogoUrl" [attr.alt]="channelName() + ' logo'" />
            </a>
          }
        </div>
      </div>
    </lib-shared-feature-sidemenu>
  </div>
</div>

@if (movie) {
  <div class="branded-movie-conversion--sharing">
    <ush-movie-tell-friends [movie]="movie!" />
  </div>

  <div class="branded-movie-conversion">
    <div class="branded-movie-conversion--head">
      <div class="branded-movie-conversion--background">
        <img [ngSrc]="movie!.tilePhotoUrl!" fill priority [alt]="movie!.title! + ' tile image'" priority="true" />
      </div>
    </div>
    <div class="branded-movie-conversion--body">
      <div class="branded-movie-conversion--logo" *ngIf="movie!.logoUrl">
        <a
          class="branded-movie-conversion--logo--wrapper"
          *ngIf="!hideLogoTitle"
          [routerLink]="[routePath, 'film-info']"
        >
          @if (movie?.logoUrl) {
            <div class="branded-movie-conversion--logo--wrapper-support">
              <img
                class="branded-movie-conversion--movie--logo"
                [ngSrc]="movie!.logoUrl!"
                sizes="(max-width:530px) 90vw, (max-width:1000px) 50vw, 30vw"
                height="150"
                width="450"
                priority="true"
                [alt]="'video thumbnail image of ' + movie?.title"
              />
            </div>
          } @else {
            <h2 *ngIf="!hideTitleText" class="branded-movie-conversion--movie--title">{{ movie?.title }}</h2>
          }
        </a>
      </div>
      <div class="branded-movie-conversion--wrapper">
        <div class="branded-movie-conversion--portrait">
          <a [routerLink]="[routePath, 'film-info']">
            <img
              [ngSrc]="movie!.portraitPhotoUrl!"
              width="360"
              height="540"
              priority="true"
              [alt]="movie!.title! + ' portrait'"
            />
          </a>
          <!-- @if (movie && hasAssets) {
            <div class="branded-movie-conversion--assets">
              <ush-assets-locker-link
                [movie]="movie"
                [hideLabel]="true"
                [label]="ASSETSLOCKER_LABEL"
                [labelButton]="ASSETSLOCKER_LABEL_BUTTON"
                style="position: relative; z-index: 1; box-shadow: 0 0 4px rgba(0, 0, 0, 0.027)"
              />
            </div>
          } -->
        </div>
        <div class="branded-movie-conversion--showtimes--wrapper">
          <div class="branded-movie-conversion--showtimes--header">
            @if (hasShowtimes) {
              <a
                class="branded-movie-conversion--showtimes--header--tab-selector"
                [class.active]="tab() === 'showtimes'"
                [class.notBrandcolorRedeable]="!isBrandColorReadable()"
                (click)="changeTab('showtimes')"
              >
                <fa-icon [icon]="faTicket" class="branded-movie-conversion--ticket-icon" />
                <h2 class="branded-movie-conversion--title" [attr.data-translate]="'title.inCinemas'">
                  {{ 'title.inCinemas' | translate }}
                </h2>
              </a>
            }
            @if (hasStreaming) {
              <a
                class="branded-movie-conversion--showtimes--header--tab-selector"
                [class.active]="tab() === 'streaming'"
                [class.notBrandcolorRedeable]="!isBrandColorReadable()"
                (click)="changeTab('streaming')"
              >
                <fa-icon [icon]="faTv" class="branded-movie-conversion--streaming-icon" />
                <h2 class="branded-movie-conversion--title" [attr.data-translate]="'title.watchAtHome'">
                  {{ 'title.watchAtHome' | translate }}
                </h2>
              </a>
            }
            @if (movie?.trailerLink) {
              <a class="branded-movie-conversion--trailer button not-fill" (click)="playTrailer()"
                ><fa-icon [icon]="faPlay" />&nbsp;<span [attr.data-translate]="'movie.menu.trailer'">
                  {{ 'movie.menu.trailer' | translate }}</span
                ></a
              >
            }
            <!-- @if (movie && hasAssets) {
              <div class="branded-movie-conversion--assets">
                <ush-assets-locker-link
                  [movie]="movie"
                  [hideLabel]="true"
                  [label]="ASSETSLOCKER_LABEL"
                  [labelButton]="ASSETSLOCKER_LABEL_BUTTON"
                />
              </div>
            } -->
          </div>
          @if (movie) {
            @switch (tab()) {
              @case ('showtimes') {
                @if (hasShowtimes) {
                  <div
                    class="branded-movie-conversion--showtimes"
                    [class.notBrandcolorRedeable]="!isBrandColorReadable()"
                  >
                    <ush-showtime-streaming-in-cinemas
                      [movie]="movie!"
                      [newFlowEnabled]="true"
                      [inCinemasAddon]="inCinemaAddon"
                      (showsLoaded)="onShowtimesLoaded()"
                    />
                  </div>
                }
              }
              @case ('streaming') {
                @if (hasStreaming) {
                  <div class="branded-movie-conversion--streaming">
                    <ush-showtime-streaming-watch-at-home
                      [movie]="movie!"
                      (streamingPlatformsLoaded)="onStreamingPlatformsLoaded()"
                    />
                  </div>
                }
              }
            }
          }
        </div>
      </div>
    </div>
  </div>
}

<div class="footer-container">
  <div #footerWrapper class="footer-container--wrapper"></div>
</div>
